import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Partners from "../../components/Partners";
import ForeignCurrencyAccounts from "../../components/ForeignCurrencyAccounts";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const Swal = require("sweetalert2");

const SarlaftPJuridica = ({
  onCancel,
  juridicalPersonForm,
  juridicalPersonReset,
  juridicalPersonState,
  successfulCreateJuridicalPerson,
  errorsCreateJuridicalPerson,
  juridicalPerson,
}) => {
  const history = useHistory();
  const [dataPartners, setDataPartners] = useState([]);
  const [dataForeignCurrencyAccounts, setDataForeignCurrencyAccounts] =
    useState([]);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const monedaExtranjera = useRef({});
  monedaExtranjera.current = watch("moneda_extranjera", "");

  const cuentasMonedaExtranjera = useRef({});
  cuentasMonedaExtranjera.current = watch("cuentas_moneda_extranjera", "");

  const [showInputPromoter, setShowInputPromoter] = useState(false);

  const handleSelectChange = (event) => {
    setShowInputPromoter(event.target.value === "Contacto con Promotor");
  };

  useEffect(() => {
    setValue("tipo_operacion", "");
  }, [monedaExtranjera.current]);

  useEffect(() => {
    if (successfulCreateJuridicalPerson) {
      Swal.fire({
        title: "Proceso exitoso!",
        text: "El formulario fue enviado exitosamente, guarda este código " +
        juridicalPerson.codigo_verificacion +
        " para firmar tu documento",
        icon: "success",
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
          downloadFile(juridicalPerson.id);
        }
      });
      try {
        let contenido={
          "to": `${juridicalPerson.email_empresarial}`,
          "expiresIn": "1500000",
          "html": `<table
          style="width: 100% !important; table-layout: fixed"
          align="center"
          bgcolor="#ececec"
        >
          <tbody>
            <tr>
              <td>
                <table
                  style="max-width: 800px; margin: auto; width: 100%"
                  align="center"
                >
                  <tbody>
                    <tr>
                      <td
                        style="
                          font-size: 16px;
                          font-weight: bold;
                          padding-top: 20px;
                          padding-bottom: 20px;
                          padding-left: 25px;
                          padding-right: 25px;
                          text-align: center;
                          color: #353e4a;
                          font-family: Arial, sans-serif;
                        "
                        align="center"
                        width="100%"
                      >
                        Solicitud de acceso recibida
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-bottom: 8px">
                        <table
                          style="
                            color: #353e4a;
                            font-family: Arial, sans-serif;
                            font-size: 15px;
                            margin: auto;
                            width: 100%;
                          "
                          align="center"
                          bgcolor="#ffffff"
                          border="0"
                        >
                          <tbody>
                            <tr>
                              <td
                                style="
                                  color: #1e80b6;
                                  padding-top: 20px;
                                  padding-bottom: 10px;
                                  padding-left: 20px;
                                  padding-right: 20px;
                                "
                              >
                                Hola ${juridicalPerson.razon_social}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style="
                                  line-height: 24px;
                                  padding-left: 20px;
                                  padding-right: 20px;
                                  padding-bottom: 10px;
                                "
                              >
                                Soy Naideth Colombia, <br />
                                Hemos recibido tu solicitud de acceso a la plataforma, 
                                <br />
                                Usa este código de verificación para subir el documento firmado
                                <b>
                                    ${juridicalPerson.codigo_verificacion}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td style="height: 5px" height="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <table
                          width="100%"
                          border="0"
                          align="center"
                          style="
                            color: #353e4a;
                            font-family: Arial, sans-serif;
                            margin: auto;
                            background-color: #ffffff;
                          "
                          cellpadding="0"
                          cellspacing="0"
                        >
                          <tbody>
                            <tr>
                              <td
                                style="padding-bottom: 15px; padding-top: 15px"
                                align="center"
                              >
                                <table>
                                  <tbody>
                                    <tr>
                                      <td
                                        align="center"
                                        style="
                                          background-color: #ef5401;
                                          padding: 7px;
                                          font-family: Arial, sans-serif;
                                        "
                                      >
                                        <a
                                          style="
                                            background-color: #ef5401;
                                            font-family: Arial, sans-serif;
                                            border: medium none;
                                            border-radius: 3px;
                                            color: white;
                                            font-size: 21px;
                                            height: 30px;
                                            text-decoration: none;
                                            padding-top: 7px;
                                            padding-bottom: 7px;
                                            padding-left: 30px;
                                            padding-right: 30px;
                                          "
                                          href="https://sarlaft.cic.travel/firmar"
                                          target="_blank"
                                          >Validar</a
                                        ><a> </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style="background-color: #ececec">
                        <table
                          width="100%"
                          border="0"
                          align="center"
                          style="
                            color: #353e4a;
                            font-family: Arial, sans-serif;
                            font-size: 14px;
                            margin: auto;
                            padding-bottom: 10px;
                          "
                        >
                          <tbody>
                            <tr>
                              <td
                                style="
                                  color: 75;
                                  font-size: 12px;
                                  padding-top: 10px;
                                  padding-bottom: 10px;
                                "
                              >
                                Este email se ha generado automáticamente. Por
                                favor, no conteste a este email.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>`,
          "channel": "Naideth_Colombia",
          "subject": "Solicitud recibida",
          "category": ""
        }
        fetch("https://notificaciones.cic.travel/api/mails", {
          method: "POST", body: JSON.stringify(contenido), headers: new Headers({
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          }),
        });
        let contenidoAviso={
          "to": "creacion.clientes@ciccolombia.travel",
          "expiresIn": "1500000",
          "html": `<table
          style="width: 100% !important; table-layout: fixed"
          align="center"
          bgcolor="#ececec"
        >
          <tbody>
            <tr>
              <td>
                <table
                  style="max-width: 800px; margin: auto; width: 100%"
                  align="center"
                >
                  <tbody>
                    <tr>
                      <td
                        style="
                          font-size: 16px;
                          font-weight: bold;
                          padding-top: 20px;
                          padding-bottom: 20px;
                          padding-left: 25px;
                          padding-right: 25px;
                          text-align: center;
                          color: #353e4a;
                          font-family: Arial, sans-serif;
                        "
                        align="center"
                        width="100%"
                      >
                      Nueva solicitud de creacion - Colombia
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-bottom: 8px">
                        <table
                          style="
                            color: #353e4a;
                            font-family: Arial, sans-serif;
                            font-size: 15px;
                            margin: auto;
                            width: 100%;
                          "
                          align="center"
                          bgcolor="#ffffff"
                          border="0"
                        >
                          <tbody>
                            <tr>
                              <td
                                style="
                                  color: #1e80b6;
                                  padding-top: 20px;
                                  padding-bottom: 10px;
                                  padding-left: 20px;
                                  padding-right: 20px;
                                "
                              >
                                Nueva solicitud de creacion, actualizacion de clientes o proveedor recibida
                              </td>
                              </tr>
                            <tr>
                              <td
                              align="center"
                              style="
                                background-color: #ef5401;
                                padding: 7px;
                                font-family: Arial, sans-serif;
                              "
                              >
                              <a
                                style="
                                  background-color: #ef5401;
                                  font-family: Arial, sans-serif;
                                  border: medium none;
                                  border-radius: 3px;
                                  color: white;
                                  font-size: 21px;
                                  height: 30px;
                                  text-decoration: none;
                                  padding-top: 7px;
                                  padding-bottom: 7px;
                                  padding-left: 30px;
                                  padding-right: 30px;
                                "
                                href="https://sarlaft.cic.travel/"
                                target="_blank"
                                >Ir a la plataforma</a
                              ><a> </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>`,
          "channel": "Naideth_Colombia",
          "subject": "Nueva solicitud de creación o actualización de cliente",
          "category": ""
        }
        fetch("https://notificaciones.cic.travel/api/mails", {
          method: "POST", body: JSON.stringify(contenidoAviso), headers: new Headers({
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          }),
        });
      } catch(err) {
        console.log('...')
      }
    }
  }, [successfulCreateJuridicalPerson]);

  const downloadFile = (id) => {
    const token = window.localStorage.getItem("token");
    const now = new Date();
    const dateNow = `${now.toISOString()}`;

    fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/juridicalPersons/download/${id}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.blob())
      .then((blob) => {
        console.log(blob);
        const a = document.createElement("a");
        const href = window.URL.createObjectURL(blob);
        a.href = href;
        a.download = `${window
          .btoa(unescape(encodeURIComponent(dateNow)))
          .toLocaleLowerCase()}.pdf`;
        a.click();
        reset();
        juridicalPersonReset();
        history.push("/firmar");
      });
  };

  const onSubmit = (data) => {
    const file_rnt_rut = data.file_rnt_rut && data.file_rnt_rut[0];
    const file_rut = data.file_rut && data.file_rut[0];
    const file_doc_repre_legal =
      data.file_doc_repre_legal && data.file_doc_repre_legal[0];
    const file_cert_existencia_legal =
      data.file_cert_existencia_legal && data.file_cert_existencia_legal[0];
    juridicalPersonForm({
      ...data,
      estado: "CREADA",
      file_rnt_rut: file_rnt_rut,
      file_rut: file_rut,
      file_doc_repre_legal: file_doc_repre_legal,
      file_cert_existencia_legal: file_cert_existencia_legal,
    });
  };

  const onSubmitPartners = (data) => {
    setValue("socios", JSON.stringify(data));
  };

  const onSubmitForeignCurrencyAccounts = (data) => {
    setValue("cuentas_extranjeras", JSON.stringify(data));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ fontSize: "14px" }} autoComplete="off" >
      <i className="fas fa-arrow-left" onClick={onCancel} style={{cursor: "pointer"}}></i>
      <h2 className="text-center text-gray-800 mb-5">Crear nueva persona jurídica</h2>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">Ciudad</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="ciudad"
            {...register("ciudad", { required: true })}
          />
        </div>
        <div className="form-group col-md-2">
          <label className="form-label">Pais</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="pais"
            {...register("pais", { required: true })}
          />
        </div>
        <div className="form-group col-md-2">
          <label className="form-label">Tipo de solicitud</label>
          <select
            id
            className="form-control  form-control-user form-select"
            name="tipo_solicitud"
            {...register("tipo_solicitud", { required: true })}
          >
            <option value="">Seleccione una opción</option>
            <option value="Nuevo">Nuevo</option>
            <option value="Renovación">Renovación</option>
            <option value="Actualización">Actualización</option>
          </select>
        </div>
        <div className="form-group col-md-2">
          <label className="form-label">Clase vinculación</label>
          <select
            id
            className="form-control  form-control-user form-select"
            name="clase_vinculacion"
            {...register("clase_vinculacion", { required: true })}
          >
            <option value="">Seleccione una opción</option>
            <option value="Cliente">Cliente</option>
            <option value="Proveedor de Servicios">
              Proveedor de Servicios
            </option>
            <option value="Actualización">Actualización</option>
            <option value="Accionista">Accionista</option>
          </select>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">¿Cómo nos encontraste?</label>
          <select
              id
              className="form-control  form-control-user form-select"
              name="fuente_referencia"
              {...register("fuente_referencia", {
                required: true,
              })}
              onChange={handleSelectChange}
            >
              <option value="">Seleccione una opción</option>
              <option value="Redes Sociales">Redes Sociales (Facebook, Instagram, Twitter, etc.)</option>
              <option value="Recomendación de un amigo">Recomendación de un amigo</option>
              <option value="Publicidad en línea">Publicidad en línea</option>
              <option value="Correo electrónico">Correo electrónico</option>
              <option value="Blog o artículo">Blog o artículo</option>
              <option value="Contacto con Promotor">Contacto con Promotor</option>
              <option value="Otro">Otro</option>
            </select>
        </div>
      </div>
      {showInputPromoter && (
        <>
          <div className="row mt-3 justify-content-end">
            <div className="form-group col-md-3">
              <label className="form-label">Nombre del promotor</label>
              <input
                type="text"
                onInput={(e) =>
                  (e.target.value = ("" + e.target.value).toUpperCase())
                }
                style={{ textTransform: "uppercase" }}
                className="form-control form-control-user"
                name="promotor"
                {...register("promotor", {
                  required: true,
                })}
              />
            </div>
          </div>
        </>
      )}
      <div className="card-header mt-3">1. PERSONA JURÍDICA</div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">Nombre razón social</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="razon_social"
            {...register("razon_social", { required: true })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Nit.</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="nit"
            {...register("nit", { required: true })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">DV</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="dv"
            {...register("dv", { required: true })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Tipo de empresa</label>
          <select
            className="form-control form-control-user form-select"
            name="tipo_empresa"
            {...register("tipo_empresa", { required: true })}
          >
            <option value="">Seleccione una opción</option>
            <option value="Pública">Pública</option>
            <option value="Privada">Privada</option>
            <option value="Mixta">Mixta</option>
          </select>
        </div>
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">Sector de la economía</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="sector_economico"
            {...register("sector_economico", { required: true })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">CIIU</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="ciiu"
            {...register("ciiu", { required: true })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Tipo de contribuyente</label>
          <select
            className="form-control form-control-user form-select"
            name="tipo_contribuyente"
            {...register("tipo_contribuyente", { required: true })}
          >
            <option value="">Seleccione una opción</option>
            <option value="Gran Contribuyente">Gran Contribuyente</option>
            <option value="Autorretenedor">Autorretenedor</option>
            <option value="Régimen Común">Régimen Común</option>
            <option value="Régimen Simple">Régimen Simple</option>
            <option value="Régimen especial o sin ánimo de lucro">
              Régimen especial o sin ánimo de lucro
            </option>
          </select>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            Fecha de const. en cámara de comercio
          </label>
          <input
            type="date"
            className="form-control form-control-user"
            name="fecha_const_camara_comercio"
            {...register("fecha_const_camara_comercio", {
              required: true,
            })}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">Correo de reservas</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="email_empresarial"
            {...register("email_empresarial", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            Certificación en sistema de gestión de sostenibilidad
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="certificacion_sostenibilidad"
              {...register("certificacion_sostenibilidad", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="certificacion_sostenibilidad"
              {...register("certificacion_sostenibilidad", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            Correo electrónico facturación electrónica
          </label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="email_facturacion"
            {...register("email_facturacion", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            SGSST (Sistema de Gestión de Salud y Seguridad en el Trabajo)
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="sgsst"
              {...register("sgsst", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="sgsst"
              {...register("sgsst", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">No. RNT</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="no_rnt"
            {...register("no_rnt", {
              required: true,
            })}
          />
        </div>
      </div>
      <div className="card-header mt-3">OFICINA PRINCIPAL</div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">Dirección</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="direccion_ofc_principal"
            {...register("direccion_ofc_principal", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Municipio</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="mcpio_ofc_principal"
            {...register("mcpio_ofc_principal", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Teléfono</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="telefono_ofc_principal"
            {...register("telefono_ofc_principal", {
              required: true,
            })}
          />
        </div>
      </div>
      <div className="card-header mt-3">Representante Legal</div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">Apellidos</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="apellidos_rep_legal"
            {...register("apellidos_rep_legal", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Nombres</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="nombres_rep_legal"
            {...register("nombres_rep_legal", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Tipo de documento</label>
          <select
            className="form-control form-control-user form-select"
            name="tipo_doc"
            {...register("tipo_doc_rep_legal", { required: true })}
          >
            <option value="">Seleccione una opción</option>
            <option value="CC">CC</option>
            <option value="CE">CE</option>
            <option value="TI">TI</option>
            <option value="RC">RC</option>
            <option value="OTRO">OTRO</option>
          </select>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">No. documento</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="nombres"
            {...register("numero_documento_rep_legal", {
              required: true,
            })}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">Fecha nacimiento</label>
          <input
            type="date"
            className="form-control form-control-user"
            name="fec_nac_rep_legal"
            {...register("fec_nac_rep_legal", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Dirección residencia</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="direccion_res_rep_legal"
            {...register("direccion_res_rep_legal", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Municipio</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="mcpio_rep_legal"
            {...register("mcpio_rep_legal", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Teléfono</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="telefono_rep_legal"
            {...register("telefono_rep_legal", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Correo electrónico</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="email_rep_legal"
            {...register("email_rep_legal", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-5">
          <label className="form-label">¿En qué oficina prefieres ser atendido?</label>
          <select
            className="form-control form-control-user form-select"
            name="office"
            {...register("office", { required: true })}
          >
            <option value="">Seleccione una opción</option>
            <option value="Bogotá">Bogotá</option>
            <option value="Medellín">Medellín</option>
            <option value="Barranquilla">Barranquilla</option>
            <option value="Cali">Cali</option>
            <option value="Pereira">Pereira</option>
            <option value="Bucaramanga">Bucaramanga</option>
          </select>
        </div>
      </div>
      <Partners onChange={onSubmitPartners} />
      <div className="card-header mt-3">
        2. PERSONAS PÚBLICAMENTE EXPUESTAS - PEP
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">
            ¿Por su cargo maneja recursos públicos?
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="maneja_recursos_publicos"
              {...register("maneja_recursos_publicos", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="maneja_recursos_publicos"
              {...register("maneja_recursos_publicos", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            ¿Por su cargo o actividad ejerce algún grado de poder público?
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="cargo_poder_publico"
              {...register("cargo_poder_publico", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="cargo_poder_publico"
              {...register("cargo_poder_publico", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            ¿Por su actividad u oficio, goza usted de reconocimiento público
            general?
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="reconocimiento_publico"
              {...register("reconocimiento_publico", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="reconocimiento_publico"
              {...register("reconocimiento_publico", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            ¿Existe algún vínculo entre usted y una persona considerada
            públicamente expuesta?
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="persona_expuesta"
              {...register("persona_expuesta", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="persona_expuesta"
              {...register("persona_expuesta", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">
            ¿Es usted sujeto de obligaciones tributarias en otro país o grupo de
            países?
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="obligaciones_trib_otro_pais"
              {...register("obligaciones_trib_otro_pais", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="obligaciones_trib_otro_pais"
              {...register("obligaciones_trib_otro_pais", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
      </div>
      <div className="card-header mt-3">3. SOSTENIBILIDAD TURÍSTICA</div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">
            Promueve la prevención del tráfico ilegal de especies
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="pre_traf_ileg_especies"
              {...register("pre_traf_ileg_especies", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="pre_traf_ileg_especies"
              {...register("pre_traf_ileg_especies", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            Registra y monitoria el consumo de agua y energia
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="mon_cons_agua_energia"
              {...register("mon_cons_agua_energia", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="mon_cons_agua_energia"
              {...register("mon_cons_agua_energia", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            Promueve el uso eficiente de recursos / realiza separación de
            residuos
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="separacion_residuos"
              {...register("separacion_residuos", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="separacion_residuos"
              {...register("separacion_residuos", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            Recicla, reutiliza y reduce el consumo de productos desechables
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="productos_desechables"
              {...register("productos_desechables", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="productos_desechables"
              {...register("productos_desechables", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">
            Promueve la prevención de la explotación sexual de niños, niñas y
            adolecentes
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="prev_explotacion_sexual"
              {...register("prev_explotacion_sexual", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="prev_explotacion_sexual"
              {...register("prev_explotacion_sexual", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            Promueve la prevención del tráfico ilegal de bienes culturales
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="bienes_culturales"
              {...register("bienes_culturales", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="bienes_culturales"
              {...register("bienes_culturales", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            Promueve y apoya la comercialización de artesanías y productos del
            país
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="comercializacion_artesanias"
              {...register("comercializacion_artesanias", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="comercializacion_artesanias"
              {...register("comercializacion_artesanias", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            Comercializa con proveedores de bienes y servicios legalmente
            constituidos
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="proveedores_bienes"
              {...register("proveedores_bienes", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="proveedores_bienes"
              {...register("proveedores_bienes", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">
            Correo electrónico para confirmar información de sostenibilidad
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="informacion_sostenibilidad"
              {...register("informacion_sostenibilidad", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="informacion_sostenibilidad"
              {...register("informacion_sostenibilidad", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
      </div>
      <div className="card-header mt-3">
        4. ACTIVIDAD EN OPERACIONES INTERNACIONALES
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">
            ¿Realiza operaciones en moneda extranjera?
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="moneda_extranjera"
              {...register("moneda_extranjera", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="moneda_extranjera"
              {...register("moneda_extranjera", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        {monedaExtranjera.current == "SI" && (
          <div className="form-group col-md-3">
            <label className="form-label"> Tipo de operación</label>
            <select
              className="form-control form-control-user form-select"
              name="tipo_operacion"
              {...register("tipo_operacion", {
                required: true,
              })}
            >
              <option value="">Seleccione una opción</option>
              <option value="Importaciones">Importaciones</option>
              <option value="Exportaciones">Exportaciones</option>
              <option value="Inversiones">Inversiones</option>
              <option value="Transferencia">Transferencia</option>
              <option value="Otra">Otra</option>
            </select>
          </div>
        )}
        <div className="form-group col-md-3">
          <label className="form-label">
            ¿Posee productos financieros en el exterior?
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="financieros_exterior"
              {...register("financieros_exterior", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="financieros_exterior"
              {...register("financieros_exterior", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">
            ¿Posee cuentas en moneda extranjera?
          </label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"SI"}
              name="cuentas_moneda_extranjera"
              {...register("cuentas_moneda_extranjera", {
                required: true,
              })}
            />
            <label className="form-check-label">SI</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              value={"NO"}
              name="cuentas_moneda_extranjera"
              {...register("cuentas_moneda_extranjera", {
                required: true,
              })}
            />
            <label className="form-check-label">NO</label>
          </div>
        </div>
      </div>
      {cuentasMonedaExtranjera.current == "SI" && (
        <ForeignCurrencyAccounts onChange={onSubmitForeignCurrencyAccounts} />
      )}
      <div className="accordion" id="accordionExample">
        <div className="card">
          <div className="card-header" id="headingFive">
            <h2 className="mb-0">
              <button
                className="btn text-left"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="true"
                aria-controls="collapseFive"
              >
                <i className="fas fa-plus"></i> 5. DECLARACIÓN NO ENCONTRARSE EN LISTAS NACIONALES O INTERNACIONALES PARA EL CONTROL LA / FT
              </button>
            </h2>
          </div>

          <div
            id="collapseFive"
            className="collapse"
            aria-labelledby="headingFive"
            data-parent="#accordionExample"
          >
            <div className="card-body">
              <p>
                Con el diligenciamiento de este formato declaro que no me encuentro en ninguna lista restrictiva de las establecidas a nivel nacional o internacional en lo referente al lavado de activos o financiación del terrorismo; así mismo declaro que mis empleados, accionistas, miembros de la junta directiva o junta de socios, representantes legales y revisor fiscal (en caso de tenerlo), tampoco se encuentren reportados en ellas y así mismo genero el compromiso de actualizar la información cuando hubieren casos y reportarla a su organización.
              </p>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header" id="headingSix">
            <h2 className="mb-0">
              <button
                className="btn collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <i className="fas fa-plus"></i> 6. CLÁUSULA DE AUTORIZACIÓN
              </button>
            </h2>
          </div>
          <div
            id="collapseSix"
            className="collapse"
            aria-labelledby="headingSix"
            data-parent="#accordionExample"
          >
            <div className="card-body">
              <p>
                Con la suscripción de este documento autorizo a CIC Colombia Travel SAS:
                <ol>
                  <li>Revelar mi información personal y de mis negocios, en caso de ser requerida por una autoridad competente en Colombia como la UIAF o la Fiscalía General de la Nación.</li>
                  <li>Ser consultado en las bases de datos que permitan prevenir el lavado de activos y financiación del terrorismo.</li>
                </ol>
                Declaro que los recursos utilizados para el cumplimiento de las obligaciones mi cargo, objeto de esta declaratoria no provienen ni provendrán de actividades ilícitas tales como el narcotráfico, terrorismo y financiamiento del terrorismo, lavado de activos, testa ferrato, tráfico de estupefacientes o delitos contra el orden constitucional, o que de alguna manera contraríen las leyes de la república, la moral o las buenas costumbres. Igualmente se genera un compromiso con CIC Colombia Travel SAS para implementar las acciones conducentes a evitar ser utilizados sin conocimiento o con consentimiento como instrumento para el ocultamiento, manejo, inversión o aprovechamiento en cualquier forma de dinero u otros bienes provenientes de actividades delictivas o para dar apariencia de legalidad a estas actividades, por lo que se genera autorización para realizar las respectivas revisiones necesarias en las diferentes bases de datos Como parte de las Políticas SAGRLAFT CIC Colombia Travel SAS, podrá terminar de manera unilateral e inmediata los contratos que tenga con su entidad cuando el cliente, sus socios o sus accionistas y/o sus administradores llegaren a ser: <ol>
                  <li>Vinculados por parte de las autoridades competentes a cualquier tipo de investigación por delitos de narcotráfico, terrorismo y financiación del terrorismo, lavado de activos, testaferrato, tráfico de estupefacientes o delitos contra el origen constitucional.</li>
                  <li>Sean incluidos en listas para el control de lavado de activos y financiación del terrorismo administradas por cualquier autoridad nacional o extranjera.</li>
                  <li>Sean condenados por parte de las autoridades competentes en cualquier tipo de proceso judicial o relacionado con la comisión de delitos de igual o similar naturaleza a los indicados en esta cláusula.</li>
                </ol>
                Quien suscribe este documento, indemnizará y mantendrá libre de cualquier daño a CIC Colombia Travel SAS por cualquier multa o perjuicio que fueran probados y que sufra CIC Colombia Travel SAS por parte del suscriptor de las obligaciones que le apliquen en materia de prevención de riesgo de lavado de activos y financiación del terrorismo, así como cualquier reclamo judicial, extrajudicial y/o administrativo que autoridades competentes inicien en contra de CIC Colombia Travel SAS por o en ocasión de dicho Con la suscripción del presente documento, el titular autoriza a CIC COLOMBIA TRAVEL SAS, para que en cumplimiento a lo señalado en la Ley 1581 de 2012 y en el Decreto 1377 de 2013, pueda recolectar, almacenar, usar y poner en circulación sus datos personales; para enviar mensajes con fines comerciales y publicitarios; para el registro en la base de datos de la Compañía; para proveer y ofrecer los servicios que esta presta y; para las demás finalidades establecidas en la Política de Tratamiento de Datos Personales que se encuentran a su disposición en www.ciccolombia.travel Los suscriptores del presente documento manifiestan que las copias de este formato PDF, serán válidas y vinculantes para ellas. El cliente suscribirá este documento enviando copia del mismo a CIC Colombia Travel SAS. Una vez recibido el formato firmado, CIC Colombia Travel SAS procederá a confirmar el recibido respondiendo al correo electrónico de contacto del cliente relacionado en este documento.” Los suscriptores acuerdan y reconocen que el documento circulado a los correos electrónicos aquí indicados, habiendo sido firmados, tiene plena validez para estos, como si el mismo existiese en su forma física. Los suscriptores tendrán la obligación de acusar de recibido el documento por este mismo medio. *Nota: Estimado cliente y/o proveedor dando cumplimiento al decreto 2242 del 2015, solicitamos un correo electrónico al cual podamos remitir factura electrónica, en caso de no cantar con dicha información tenga en cuenta que se utilizara el correo electrónico registrado en su RUT. En caso de marcar que es exento de impuestos, se deberá contar con evidencias, de lo contrario se aplicaran los impuestos que define la ley Colombiana. En caso de ser extranjero, remitir copia de su cédula de extranjería o pasaporte.
              </p>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header" id="headingSeven">
            <h2 className="mb-0">
              <button
                className="btn collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <i className="fas fa-plus"></i>  7. DECLARACIÓN DE ORIGEN DE FONDOS
              </button>
            </h2>
          </div>
          <div
            id="collapseSeven"
            className="collapse"
            aria-labelledby="headingSeven"
            data-parent="#accordionExample"
          >
            <div className="card-body">
              <p>
                Con el propósito de que pueda dar cumplimiento a lo señalado al respecto en el Estatuto Orgánico del Sistema Financiero (Decreto 663 de 1993), la Circular Externa No. 007 de 1996, expedida por la Superintendencia Financiera y demás normas legales para el control de las actividades de lavado de activos vigentes en Colombia; en particular para cumplir con lo establecido en el artículo 27 de la ley 1121 de 2006. 1. Declaro que esta fuente de fondos en ningún caso involucra actividades ilícitas propias o de terceras personas y en todos los casos son fondos propios y por lo tanto no hemos prestado nuestro nombre para que terceras personas con recursos obtenidos ilícitamente efectúen inversiones a nombre nuestro. 2. La información aquí suministrada corresponde a la realidad y autorizo su verificación ante cualquier persona pública o privada sin limitación alguna, desde ahora y mientras subsista alguna relación contractual con CIC COLOMBIA TRAVEL SAS. o con quien represente sus derechos. 3. Los recursos que poseo provienen de las siguientes fuentes (detallo ocupación, oficio, actividad o negocio):
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="card-header mt-3">8. DOCUMENTOS REQUERIDOS</div>
      <div className="row mt-3">
      <div className="form-group col-md-12">
          <label className="form-label">
            1. Fotocopia de RNT actualizado
          </label>
          <input
            id
            type="file"
            className="form-control form-control-user"
            name="file_rnt_rut"
            {...register("file_rnt_rut", {
              required: true,
            })}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-12">
          <label className="form-label">
            2. Fotocopia de RUT actualizado
          </label>
          <input
            id
            type="file"
            className="form-control form-control-user"
            name="file_rut"
            {...register("file_rut", {
              required: true,
            })}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-12">
          <label className="form-label">
            3. Fotocopia del documento de identidad del representante legal
          </label>
          <input
            type="file"
            className="form-control form-control-user"
            name="file_doc_repre_legal"
            {...register("file_doc_repre_legal", {
              required: true,
            })}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-12">
          <label className="form-label">
            4. Certificado de existencia y representación legal con vigencia no
            superior a 30 día para personas jurídicas
          </label>
          <input
            type="file"
            className="form-control form-control-user"
            name="file_cert_existencia_legal"
            {...register("file_cert_existencia_legal", {
              required: true,
            })}
          />
        </div>
        <input
          id
          type="hidden"
          className="form-control form-control-user"
          name="sys"
          value="COL"
          {...register("sys")}
        />
      </div>
      <div class="modal-footer justify-content-center">
        <button type="submit" className="btn btn-danger p-3 col-sm-3 col-10 mt-2" style={{ borderRadius: "50px" }}>
          Enviar
        </button>
      </div>
    </form>
  );
};

const mapStateToProps = (state) => {
  return {
    juridicalPersonState: state.juridicalPersonState,
    successfulCreateJuridicalPerson:
      state.juridicalPersonState.successfulCreateJuridicalPerson,
    errorsCreateJuridicalPerson:
      state.juridicalPersonState.errorsCreateJuridicalPerson,
    juridicalPerson: state.juridicalPersonState.juridicalPerson,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    juridicalPersonForm: (payload) =>
      dispatch({
        type: "CREATE_JURIDICAL_PERSON_REQUEST",
        value: payload,
      }),
    juridicalPersonReset: () =>
      dispatch({
        type: "CREATE_JURIDICAL_PERSON_RESET",
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SarlaftPJuridica);
